import React from "react";
import styles from "./LoadingSpinner.module.css";
import i18n from "../Services/i18n";
import spinner from "../Assets/loading_horse_gray.gif";

const LoadingSpinner = () => {
  return (
    <div>
      <div className={styles.spinnerContainer}>
        <div className={styles.spinner}></div>
        <div className={styles.centerImage}>
          <img src={spinner} alt="center" />
        </div>
      </div>
      {i18n.t("LoadingSpinner.Loading")}
    </div>
  );
};

export default LoadingSpinner;
